import React from 'react';
import { Trans } from '@lingui/macro';

function About() {
  return (
    <section className="section" id="about">
      <div className="bg-overlay bg-gradient-tertiary" style={{ opacity: 0.85 }}></div>
      <div className="about-particles">
        {[...Array(20)].map((_, i) => (
          <div key={i} className="particle" style={{ '--delay': `${Math.random() * 10}s`, '--x': `${Math.random() * 100}%`, '--duration': `${10 + Math.random() * 10}s` }}></div>
        ))}
      </div>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 mb-4 pb-2">
            <div className="section-title text-center">
              <h4 className="title text-white mb-4">
                <Trans>ABOUT US</Trans>
              </h4>
              <p className="text-white para-desc mx-auto mb-4">
                <Trans>
                  The name Amare, derived from the Latin word meaning "to love", reflects the heartbeat of our festival—a celebration of the boundless energy that flows through us all.
                </Trans>
              </p>
              <p className="text-white para-desc mx-auto mb-4">
                <Trans>
                  Here, music is more than sound; it’s a force that unites, heals, and connects us to the very essence of our existence.
                </Trans>
              </p>
              <p className="text-white para-desc mx-auto mb-4">
                <Trans>
                  At the core of our identity is the Triquetra, an ancient symbol that embodies the eternal cycle of past, present, and future.
                </Trans>
              </p>
              <p className="text-white para-desc mx-auto mb-4">
                <Trans>
                  In our logo, the Triquetra is inside the letter "A" of Amare, symbolizing the unbreakable bond between beginning, the journey, and what lies ahead.
                </Trans>
              </p>
              <p className="text-white para-desc mx-auto mb-0">
                <Trans>
                  It’s a reminder that love and vibration are timeless, transcending boundaries and connecting us to something greater than ourselves.
                </Trans>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;

